import { AccountSettingsTab } from '@components/layouts/Truva/AccountSettings/AccountSettings';
import actions from '..';
import fetchCurrentUser from './fetchCurrentUser';
import { loadedPage } from './analytics';

const accountSettingsPageLoad = (tab: NonNullable<AccountSettingsTab>) => async dispatch => {
  await dispatch(actions.setAccountSettingsPage());
  dispatch(fetchCurrentUser());
  dispatch(loadedPage(tab));
};

export default accountSettingsPageLoad;
